<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">
      <mat-form-field>
        <mat-label>Rule Name</mat-label>
        <input [(ngModel)]="search.rrName" matInput name="name">
      </mat-form-field>

      <ac-input-container label="Live">
        <ac-select [(acModel)]="search.adminState"
                   [items]="search.adminStateOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Quality">
        <ac-select [(acModel)]="search.quality"
                   [items]="search.qualityOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Stop ARM Routing">
        <ac-select [(acModel)]="search.isContinueWithNodeInternalTables"
                   [items]="search.isContinueWithNodeTablesOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Loopback">
        <ac-select [(acModel)]="search.isLoopback"
                   [items]="search.discardOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

    </div>
    <div class="search-column">

      <mat-form-field>
        <mat-label>Group Name</mat-label>
        <input [(ngModel)]="search.rrGroupName" matInput name="name">
      </mat-form-field>

      <ac-input-container label="Test">
        <ac-select [(acModel)]="search.testMode"
                   [items]="search.adminStateOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Discard">
        <ac-select [(acModel)]="search.isDiscard"
                   [items]="search.discardOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>
      <ac-input-container label="Registered Users">
        <ac-select [(acModel)]="search.isRegisteredUsers"
                   [items]="search.registeredUsersOptions"
                   [bindValue]="'value'"
                   [bindLabel]="'text'"
                   [allowClear]="true">
        </ac-select>
      </ac-input-container>
      <ac-input-container label="Call Type">
        <ac-select  [(acModel)]="search.requestType"
                    [items]="search.requestTypeOptions"
                    [bindValue]="'value'"
                    [bindLabel]="'text'"
                    [allowClear]="true">
        </ac-select>

      </ac-input-container>

    </div>
  </div>
</arm-dialog>

